/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type SimulateAuthorizationRequestOptsActionType = typeof SimulateAuthorizationRequestOptsActionType[keyof typeof SimulateAuthorizationRequestOptsActionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimulateAuthorizationRequestOptsActionType = {
  PURCHASE: 'PURCHASE',
  ATM: 'ATM',
  REPAYMENT_CONFIRMED: 'REPAYMENT_CONFIRMED',
} as const;
